module.exports = __webpack_public_path__ + "static/media/tap_button2_img.1b11f9b8.png";